module.exports = __webpack_public_path__ + "career-icon-vacation.3pPIuPcO.svg";